import React, { useState, useEffect } from 'react';
import { makeApiCal, POST } from '../../AppConfig';
import { infoBlack, Bullet, TnC } from '../../../../assets/images/images';
function Modal({
  closeAction,
  howToRedeem,
  termsAndConditions,
  websiteLink,
  websiteLink2,
  voucher,
}) {
  const [showLink, setShowLink] = useState('');
  const [showLink2, setShowLink2] = useState('');

  const action = {
    method: POST,
    route: 'v2/storeDeeplink',
    body: {
      deeplink: {
        screen: 'STUDENT_END_REWARDS',
        paramOne: '',
        paramTwo: '',
        paramTracking: voucher,
      },
    },
    storeData: (e) => console.log(e),
    catchError: (e) => console.error(e),
  };

  useEffect(() => {
    if (howToRedeem && howToRedeem.linkText) {
      let displayLink = decodeURIComponent(howToRedeem.linkText);
      setShowLink(displayLink);
    }
    if (howToRedeem && howToRedeem.linkText2) {
      let displayLink2 = decodeURIComponent(howToRedeem.linkText2);
      setShowLink2(displayLink2);
    }
  }, []);

  return (
    <div className="Modal">
      <div className="Backdrop" onClick={closeAction}></div>
      <div className="Modal__Content">
        <div className="Modal__Content__Header">
          <div className="Modal__Content__Header--Label">
            Your Reward Details
          </div>
          <div className="Modal__Content__Header--Close" onClick={closeAction}>
            &#10006;
          </div>
        </div>
        {howToRedeem && (
          <div className="Modal__Content__Redeem">
            <div className="Modal__Content__Redeem__Label">
              <img loading="lazy" fill="#000" src={infoBlack} alt="" /> How to
              Redeem
            </div>
            <div className="Modal__Content__Redeem__Body">
              {showLink && (
                <div
                  onClick={() => {
                    window.open(websiteLink, '_blank');
                    makeApiCal(action);
                  }}
                  dangerouslySetInnerHTML={{ __html: showLink }}
                />
              )}
              {showLink2 && (
                <div
                  onClick={() => {
                    window.open(websiteLink2, '_blank');
                    makeApiCal(action);
                  }}
                  dangerouslySetInnerHTML={{ __html: showLink2 }}
                />
              )}

              {howToRedeem &&
                howToRedeem.bulletPoints &&
                howToRedeem.bulletPoints.map((point, i) => {
                  return (
                    <div key={i} className="Modal__Content__Redeem__Body--Item">
                      <img loading="lazy" src={Bullet} alt="" />
                      <span>{point}</span>
                    </div>
                  );
                })}
            </div>
          </div>
        )}

        {termsAndConditions &&
          termsAndConditions.bulletPoints &&
          termsAndConditions.bulletPoints.length > 0 && (
            <div
              className="Modal__Content__Redeem"
              style={{ marginTop: '24px' }}
            >
              <div className="Modal__Content__Redeem__Label">
                <img loading="lazy" src={TnC} alt="" />
                Terms & Conditions
              </div>
              <div className="Modal__Content__Redeem__Body">
                {termsAndConditions && (
                  <div
                    dangerouslySetInnerHTML={{
                      __html: termsAndConditions.linkText,
                    }}
                  />
                )}
                {termsAndConditions &&
                  termsAndConditions.bulletPoints &&
                  termsAndConditions.bulletPoints.map((point, i) => {
                    return (
                      <div
                        key={i}
                        className="Modal__Content__Redeem__Body--Item"
                      >
                        <img loading="lazy" src={Bullet} alt="" />
                        <span>{point}</span>
                      </div>
                    );
                  })}
              </div>
            </div>
          )}
      </div>
    </div>
  );
}

export default Modal;
